<div
  *ngIf="isLoading"
  class="loading-skeleton-bar"
  style="height: 100%; width: 100%"
>
  <div>Učivatanje dokumenta...</div>
</div>
<div
  [ngStyle]="{ visibility: isLoading ? 'hidden' : 'visible', height: '100%' }"
>
  <!-- pdf -->
  <ng2-pdfjs-viewer
    *ngIf="isPdf"
    [pdfSrc]="fileUrlEncoded"
    [showSpinner]="false"
    locale="sr-Latn"
    [openFile]="false"
    [download]="true"
    [viewBookmark]="false"
    cursor="hand"
  >
  </ng2-pdfjs-viewer>

  <!-- img -->
  <div *ngIf="isImage" class="image-preview-wrapper">
    <img
      [src]="fileUrlRaw"
      class="image-preview"
      alt="Dokument"
    />
  </div>

  <!-- ostalo - fallback -->
  <div *ngIf="!isPdf && !isImage">
    Nepodržan tip fajla ({{ mimeType }})
  </div>
  
</div>
